<template>
  <div class="input-group">
   
    <input required
      ref="input"
      :id="label_id"
      type="datetime-local" 
      class="form-control" 
      :value="getIsoDate(value)"
      @input="setMySQLDate($event.target.value)"
    >

    <div class="input-group-btn dropup">
     
      <button type="button"
        class="btn btn-primary dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        <span class="glyphicon glyphicon-menu-hamburger" aria-hidden="true"></span>
      </button>
      
      <ul class="dropdown-menu dropdown-menu-right">
        <li><a @click="setMySQLDate('now')">Heute</a></li>
        <li><a @click="setMySQLDate('tomorrow')">Morgen 08:00</a></li>
        <li><a @click="setMySQLDate('2029-12-31T00:00')">31.12.2029 </a></li>
      </ul>
      
    </div>
    
  </div>

</template>



<script>
  
import moment from 'moment'


// Alternative: http://xdsoft.net/jqplugins/datetimepicker/

export default {
  
  data () {
    return {
      
    }
  },
  
  props: ['value','label_id'],
  
  created: function () {
    
  },
  
  
  methods: {
    
    getIsoDate: function (date) {
      
      return moment(date).format('YYYY-MM-DDTHH:mm'); 
    },
    
    setMySQLDate: function (value) {
      
      if(value == 'now'){
        this.$emit('input', moment().format('YYYY-MM-DD HH:mm:ss'));
      }else if(value == 'tomorrow'){
        let tomorrow = moment().add(1, 'day').hour(8).minute(0);
        this.$emit('input',tomorrow.format('YYYY-MM-DD HH:mm:ss'));
      }else{
        this.$emit('input', moment(value).format('YYYY-MM-DD HH:mm:ss'));
        //this.$refs.input.value = moment(value).format('YYYY-MM-DD HH:mm:ss')
        
      }
      
    },
    

  },
  
}
  
</script>



<style scoped>

input:invalid {
  border: 1px solid red;
}  

</style>



// WEBPACK FOOTER //
// datetime.vue?5633d6de